import { useEffect, useState } from 'react';
import { useLocation } from 'react-router';
import { I18n } from 'aws-amplify';
import Constant from '@/common/constant/Constant';
import Utils from '@/common/utils/utils';
import { Tooltip } from '@material-ui/core';
import { useSnackbar } from 'notistack';

import BulkActionDropdown from './BulkActionDropdown';
import ConfirmDialog from '@/common/dialog/ConfirmDialog';
import {
    handleMsgDialogConfirmByBulkAction,
    handleMsgPendingWhenBulkActionInProcessing,
    handleBulkUpdateTicketAPI,
    permissionShowOptionMultiShareRange,
    handleTxtSubmitAndCancelActionPopup,
    permissionDuplicateTicket
} from '../handler/ListTicketKnowledgeHandler';
import { useRecoilState, useRecoilValue } from 'recoil';
import { userAtom } from '@/state/atom/userAtom';
import {
    bulkActionKnowledgeTaskIdAtom,
    destinationPrjIdAtom
} from '@/state/atom/ticketKnowledgeAtom';
import { formListOfProjectSelector } from '@/state/selector/formSelector' ;
import { handleOpenLogScreen } from '../handler/KnowledgeUploadCsvHandler';
import { cloneDeep } from 'lodash';
import { projectListInCorporationByUserIdAtom } from '@/state/atom/projectAtom';

function BulkAction({
    listTicketKnowledge = [],
    totalTickets = 0,
    viewSelected,
    selectedProject,
    onSubmitSearchListKnowledge,
    currentSearchParams,
    isHasEditPermissionSomeTicket,
    drillDownData,
    viewStructure,
    isProjectManager,
    projectInuseDetail,
    setIsShowEditRangeMulti,
    setIsShowEditTagField,
    setIsShowDialogNotiLimit,
    msgInProcessingIcon,
    setMsgInProcessingIcon,
    setLimitNotiMessage,
    corporationDetail,
    selectedFilterForm,
    setSelectedFilterForm,
    setIsShowExportMenu,
    isOpenDialogConfirm,
    setIsOpenDialogConfirm,
    formIdSearchConditionFilterBy
}) {
    const location = useLocation();
    // Atom
    const projectList = useRecoilValue(projectListInCorporationByUserIdAtom);
    const userDetail = useRecoilValue(userAtom);
    const [knowledgeTaskId , setKnowledgeTaskId ] = useRecoilState(bulkActionKnowledgeTaskIdAtom);
    const destinationPrjId = useRecoilValue(destinationPrjIdAtom);
    const formList = useRecoilValue(formListOfProjectSelector);

    const [bulkActionList, setBulkActionList] = useState([]);
    
    const [errorDialog, setErrorDialog] = useState({
        enable: false,
        msg: ""
    });
    const [disableButtonCallBack, setDisableButtonCallBack] = useState(false);
    const { enqueueSnackbar } = useSnackbar();

    const validateDisableForActionList = (actionList,isLiveAndPublicView) => {
        const structure = Utils.convertJSONDataToObject(viewSelected?.structure);
        const ticketProperty = structure?.ticketProperty;

        actionList = actionList.map(action => {

            if ([Constant.BULK_ACTION.DELETE, Constant.BULK_ACTION.HARD_DELETE, Constant.BULK_ACTION.RESTORE].includes(action.type)) {
                action.disable = !isHasEditPermissionSomeTicket;
            }

            // Back to draft enable condition
            if (action.type === Constant.BULK_ACTION.BACK_TO_DRAFT) {
                action.disable = true;
                if (isLiveAndPublicView && destinationPrjId === projectInuseDetail?.id) {
                    let isUserCreatedTicketInList = listTicketKnowledge.find(ticket => ticket.creator === userDetail?.id && [Constant.TICKET_TYPE.KNOWLEDGE, Constant.TICKET_TYPE.MASTER_KNOWLEDGE].includes(ticket.ticketType));
                    if (!Utils.isEmptyObject(isUserCreatedTicketInList)) {
                        action.disable = false;
                    } else if (!Utils.isEmptyArray(drillDownData)) {
                        let userListInDrilldown = drillDownData.find(drilldownData => drilldownData.id === 'creator');
                        if (userListInDrilldown && !Utils.isEmptyObject(userListInDrilldown) && !Utils.isEmptyArray(userListInDrilldown.child)) {
                            let currentUserCreateTicketData = userListInDrilldown.child.find(userDrilldownData => userDrilldownData?.id === userDetail?.id && userDrilldownData.total);
                            if (currentUserCreateTicketData && !Utils.isEmptyObject(currentUserCreateTicketData)) {
                                action.disable = false;
                            }
                        }
                    }
                }
            }

            if (action.type === Constant.BULK_ACTION.SENT_TO_PUBLIC) {
                action.disable = true;

                if (totalTickets && selectedProject === Constant.KNOWLEDGE_VIEW_OPTION.PRJ_IN_USE && ticketProperty === Constant.TICKET_PROPERTY.DRAFT) {
                    action.disable = false;
                }
            }
            //export to csv
            if(action.type === Constant.BULK_ACTION.EXPORT_CSV){
                action.disable = !formIdSearchConditionFilterBy();
            }

            // Duplicate knowledge ticket
            if (action.type === Constant.BULK_ACTION.DUPLICATE) {
                action.disable = !formIdSearchConditionFilterBy();
            }


            return action
        });

        // Filter for Show action EDIT_PUBLIC_RANGE in view
        actionList = actionList.filter(action => {
            return (
                ![Constant.BULK_ACTION.EDIT_PUBLIC_RANGE].includes(action.type) ||
                ([Constant.BULK_ACTION.EDIT_PUBLIC_RANGE].includes(action.type) &&
                    permissionShowOptionMultiShareRange(projectList, destinationPrjId))
            );
        });

        return actionList;
    }

    let formSelectedInSearchCondition = formIdSearchConditionFilterBy();


    // handle bulkActionList option
    useEffect(() => {
        let ticketProperty = Constant.TICKET_PROPERTY.SENT;
        let structure = Utils.convertJSONDataToObject(viewSelected?.structure);
        if (!Utils.isEmptyObject(structure)) {
            ticketProperty = structure?.ticketProperty;
        }
        let initBulkActionList = Constant.BULK_ACTION_LIST;
        let isLiveAndPublicView = false;
        
        switch (ticketProperty) {
            case Constant.TICKET_PROPERTY.SENT:
            case Constant.TICKET_PROPERTY.SYNONYM:
                isLiveAndPublicView = true;
                initBulkActionList = initBulkActionList.filter(action => {
                    return ![Constant.BULK_ACTION.SENT_TO_PUBLIC, Constant.BULK_ACTION.RESTORE].includes(action.type)
                });
                break;
            case Constant.TICKET_PROPERTY.DRAFT:
                initBulkActionList = initBulkActionList.filter(action => {
                    return ![Constant.BULK_ACTION.BACK_TO_DRAFT, Constant.BULK_ACTION.RESTORE].includes(action.type)
                });
                break;
            case Constant.TICKET_PROPERTY.DELETE:
                initBulkActionList = initBulkActionList
                    .filter(action => {
                        return [Constant.BULK_ACTION.DELETE, Constant.BULK_ACTION.RESTORE].includes(action.type)
                    })
                    .map(action => {
                        if (action.type === Constant.BULK_ACTION.DELETE) {
                            return {
                                ...action,
                                type: Constant.BULK_ACTION.HARD_DELETE
                            }
                        }
                        return action
                    });
                break;
            default:
                break;
        }

        if (destinationPrjId !== projectInuseDetail.id) {
            initBulkActionList = initBulkActionList.filter(action => {
                return action.type !== Constant.BULK_ACTION.BACK_TO_DRAFT
            });
        } else {
            isLiveAndPublicView = true;
        }

        if (!permissionDuplicateTicket(corporationDetail, projectInuseDetail)) {
            initBulkActionList = initBulkActionList.filter(action => {
                return action.type !== Constant.BULK_ACTION.DUPLICATE
            });
        }
        
        if (
            Utils.isEmptyArray(listTicketKnowledge)
            || (!Utils.isEmptyArray(listTicketKnowledge)
                && listTicketKnowledge.every(ticket => ticket.ticketType === Constant.TICKET_TYPE.PDF_PAGE_KNOWLEDGE))
        ) {
            initBulkActionList = initBulkActionList.map(action => ({
                ...action,
                disable: true
            }));
        } else {
            initBulkActionList = validateDisableForActionList(initBulkActionList,isLiveAndPublicView)
        }

        setBulkActionList(initBulkActionList);

    }, [viewSelected, isHasEditPermissionSomeTicket, viewStructure, drillDownData, listTicketKnowledge, formList, selectedFilterForm]);

    useEffect(()=> {
        if(!Utils.isEmptyObject(selectedFilterForm)){
            let formSelectedInSearchConditionDetail = formList.find(form => form.id === selectedFilterForm.id);
            const usingProjectOfSelectedForm = Utils.convertJSONDataToObject(selectedFilterForm.usingProjects)
            if(!Utils.isEmptyObject(formSelectedInSearchConditionDetail)){
                const usingProject = formSelectedInSearchConditionDetail.usingProjects;
                if(!usingProject.includes(projectInuseDetail.id) && usingProjectOfSelectedForm.includes(projectInuseDetail.id)){
                    let selectedFilterFormClone = cloneDeep(selectedFilterForm);
                    selectedFilterFormClone.usingProjects = usingProject;
                    setSelectedFilterForm(selectedFilterFormClone)
                }

                if(usingProject.includes(projectInuseDetail.id) && !usingProjectOfSelectedForm.includes(projectInuseDetail.id)){
                    let selectedFilterFormClone = cloneDeep(selectedFilterForm);
                    selectedFilterFormClone.usingProjects = usingProject;
                    setSelectedFilterForm(selectedFilterFormClone)
                }
            }
        }
    },[formList])

    const handleAction = async (actionType) => {
        let params = {
            searchCondition: JSON.stringify(currentSearchParams)
        };
        const structure = Utils.convertJSONDataToObject(viewSelected?.structure);
        const currentViewType = structure?.ticketProperty;
        setIsShowEditTagField(false);
        setIsShowExportMenu(false);
        switch (actionType) {
            case Constant.BULK_ACTION.EDIT_TAG_FIELD:
                setIsShowEditTagField(true);
                setIsShowEditRangeMulti(false);
                return;
            case Constant.BULK_ACTION.EDIT_PUBLIC_RANGE:
                setIsShowEditRangeMulti(true);
                break;
            case Constant.BULK_ACTION.EXPORT_CSV:
                if (currentViewType === Constant.TICKET_PROPERTY.DELETE) return; // export csv will not work in trash view.
                params.action = Constant.BULK_ACTION.EXPORT_CSV;
                setIsOpenDialogConfirm({
                    status: false,
                    action: params.action,
                    params: { ...params },
                });
                setIsShowExportMenu(true);
                setIsShowEditRangeMulti(false);
                return;
            case Constant.BULK_ACTION.BACK_TO_DRAFT:
                params.action = Constant.BULK_ACTION.BACK_TO_DRAFT;
                break;
            case Constant.BULK_ACTION.SENT_TO_PUBLIC:
                params.action = Constant.BULK_ACTION.SENT_TO_PUBLIC;
                break;
            case Constant.BULK_ACTION.DUPLICATE:
                if (!selectedFilterForm || Utils.isEmptyObject(selectedFilterForm)) {
                    setLimitNotiMessage(I18n.get('MSG-KNOW-FORM-NOT-SHARE'));
                    setIsShowDialogNotiLimit(true);
                    return;
                }
                params.action = Constant.BULK_ACTION.DUPLICATE;
                let usingProjects = Utils.convertJSONDataToObject(selectedFilterForm.usingProjects);
                let isCurrentProjectUsingFormSelected = usingProjects?.includes(
                    projectInuseDetail.id
                )
                    ? true
                    : false;
                params.forceActiveFormWhenDuplicate = isCurrentProjectUsingFormSelected
                    ? false
                    : true;
                params.newOrder = !Utils.isEmptyArray(formList) ? formList.length + 1 : 1;
                params.formSelectedInSearchCondition = formSelectedInSearchCondition;
                break;
            case Constant.BULK_ACTION.DELETE:
            case Constant.BULK_ACTION.HARD_DELETE:
                params.action =
                    currentViewType === Constant.TICKET_PROPERTY.DELETE
                        ? Constant.BULK_ACTION.HARD_DELETE
                        : Constant.BULK_ACTION.SOFT_DELETE;
                break;
            case Constant.BULK_ACTION.RESTORE:
                params.action = Constant.BULK_ACTION.RESTORE;
                break;
            default:
                break;
        }
        if (actionType !== Constant.BULK_ACTION.EDIT_PUBLIC_RANGE) {
            setIsOpenDialogConfirm({
                status: true,
                action: params.action,
                params: {...params}
            });
            setIsShowEditRangeMulti(false);
        }
    };

    const isDisableBulkBtn = () => {
        return (
            totalTickets == 0
        )
    }

    const isUsingFormInProject = () => {
        let isUsing = false;
        if(!Utils.isEmptyObject(selectedFilterForm)){
            let usingProjects = Utils.convertJSONDataToObject(selectedFilterForm?.usingProjects)
            isUsing = usingProjects?.includes(projectInuseDetail.id) ? true : false;
        }

        return isUsing 
    }

    return (
        <>
            <div className="bulk-action">
                <div className="bulk-action-left">
                    <span className="option-name">
                        <strong>検索結果：{totalTickets}件</strong>
                    </span>
                </div>

                <div className="bulk-action-right">
                    {destinationPrjId && (
                        <>
                        <BulkActionDropdown
                            bulkActionList={bulkActionList}
                            handleAction={handleAction}
                            disableBulkBtn={isDisableBulkBtn()}
                            pendingBulkBtn={!Utils.isEmptyString(knowledgeTaskId)}
                        />
                        <img
                            className="option-icon"
                            src="/assets/image/process-upload-csv.svg"
                            alt="icon-view-log"
                            onClick={() => handleOpenLogScreen(`${location.pathname}/log-screen/bulk-actions`)}
                        />
                        </>
                    )}
                    <img
                        className="option-icon"
                        src={`/assets/image/icon-reload.svg`}
                        alt="icon-reload"
                        onClick={() => onSubmitSearchListKnowledge()}
                    />
                    {!Utils.isEmptyString(knowledgeTaskId) && (
                        <Tooltip title={I18n.get(msgInProcessingIcon)} arrow placement="right-end">
                            <img
                                className="option-icon icon-loading"
                                src={`/assets/image/icon-loading.svg`}
                                alt="icon-loading"
                            />
                        </Tooltip>
                    )}
                </div>
            </div>

            <ConfirmDialog
                isOpen={isOpenDialogConfirm.status}
                msgConfirm={I18n.get(handleMsgDialogConfirmByBulkAction(isOpenDialogConfirm.action, selectedFilterForm, isUsingFormInProject())).replace('[number]', totalTickets)
                    .replace('「Form_name」', Utils.convertJSONDataToObject(selectedFilterForm?.name)?.jp?.text)
                }
                closeCallBack={(e, reason) => {
                    if (e && reason === 'backdropClick') return false;
                    setIsOpenDialogConfirm({
                        status: false,
                        action: '',
                        params: {}
                    });
                    return;
                }}
                okCallBack={() => {
                    if ((totalTickets > Constant.LIMIT_TICKET_UPDATE_MULTI && isOpenDialogConfirm.action !== Constant.BULK_ACTION.EXPORT_CSV) || (totalTickets > Constant.LIMIT_TICKET_EXPORT && isOpenDialogConfirm.action === Constant.BULK_ACTION.EXPORT_CSV)) {
                        setIsOpenDialogConfirm({
                            status: false,
                            action: '',
                            params: {}
                        });
                        if (isOpenDialogConfirm.action === Constant.BULK_ACTION.EXPORT_CSV) {
                            setLimitNotiMessage(I18n.get('MSG-CM-OVER-SIZE-FILE-ERROR-WHEN-EXPORT-CSV'));
                        }
                        setIsShowDialogNotiLimit(true);
                        return;
                    }

                    setDisableButtonCallBack(true);
                    setMsgInProcessingIcon(
                        handleMsgPendingWhenBulkActionInProcessing(isOpenDialogConfirm.action)
                    );
                    setIsShowExportMenu(false)
                    document.body.style.cursor='wait';
                    handleBulkUpdateTicketAPI(
                        isOpenDialogConfirm,
                        setIsOpenDialogConfirm,
                        setKnowledgeTaskId,
                        setDisableButtonCallBack,
                        enqueueSnackbar
                    )
                    return;
                }}
                textSubmit={I18n.get(handleTxtSubmitAndCancelActionPopup(isOpenDialogConfirm.action)?.submit)}
                textClose={I18n.get(handleTxtSubmitAndCancelActionPopup(isOpenDialogConfirm.action)?.cancel)}
                disableButtonCallBack={disableButtonCallBack}
            />

            <ConfirmDialog
                isOpen={errorDialog.enable}
                msgConfirm={I18n.get(errorDialog.msg)}
                okCallBack={() => {
                    setMsgInProcessingIcon("")
                    setErrorDialog({enable: false, msg:""})
                }}
            />
        </>
    );
}

export default BulkAction;
